<app-dialog
        [dialogWithInput]="dialog">
    <app-view-by-attribute
            [value]="dialog.input.purchaseOrderSummary.account.businessCode"
            [findByAttributeService]="configurationService"
            (entityLoaded)="configurationLoaded($event)">
        <ng-container *ngIf="configuration">
            <div class="row">
                <div class="col-12">
                    <app-card-v2 [hideHeader]="true">
                        <app-email-content-form
                                [formGroup]="formGroup"
                                [initialSubject]="initialSubject"
                                [initialContent]="initialContent"
                                [initialTo]="initialTo"
                                [formatContentService]="formatContentActionService"
                                [buildFormatContentPayload]="buildFormatContentPayload"
                                [substitutionAdditionalCategoryValues]="['COMMUNICATION_CONTENT_SUBSTITUTION_CATEGORY_PURCHASE_ORDER',
                            'COMMUNICATION_CONTENT_SUBSTITUTION_CATEGORY_USER',
                            'COMMUNICATION_CONTENT_SUBSTITUTION_CATEGORY_PATIENT']">
                        </app-email-content-form>
                    </app-card-v2>
                </div>
            </div>
        </ng-container>
    </app-view-by-attribute>
    <div dialog-actions class="text-center">
        <app-loading [showText]="false" [loading]="sendEmailService.loading$ | async"></app-loading>
        <app-error-text [error]="sendEmailService.error$ | async"></app-error-text>
        <app-button size="small"
                    label="Envoyer"
                    fill="solid"
                    color="primary"
                    (clickEvent)="send()"
                    *ngIf="(sendEmailService.loading$ | async) === false"
                    [disabled]="!formGroup.valid || !configuration"></app-button>
    </div>
</app-dialog>
